import React, { Component } from "react";
import { connect } from "react-redux";
import { Row } from "react-bootstrap";

class PredictionBar extends Component {
  gRGB = null;
  constructor(props) {
    super(props);
    this.state = {
      preds: 0,
    };
  }

  receivePreds = (preds) => {
    this.setState({
      preds: preds,
    });
  };

  randomizeBarColor = () => {
    let r = Math.floor(Math.random() * 256); // Random between 0-255
    let g = Math.floor(Math.random() * 256); // Random between 0-255
    let b = Math.floor(Math.random() * 256); // Random between 0-255
    let rgb = "rgb(" + r + "," + g + "," + b + ")"; // Collect all to a string
    this.gRGB === rgb ? this.randomizeBarColor() : (this.gRGB = rgb);
  };

  componentDidMount() {
    this.randomizeBarColor();
  }

  render() {
    let value;
    if(!this.props.preds)
      value = 0
    else if((this.props.preds*100) < 1.5)
      value = 0
    else 
      value = this.props.preds
      
    return (
      <div
        style={{
          //height: "201px",
          width: "312px",
          marginTop: "29px",
          textAlign: "left",
        }}
      >
        <Row>
          <div
            style={{
              fontSize: "12px",
              color: "#C2C0BD",
              height: "14px",
              width: "99px",
              paddingLeft: "15px",
              fontSize: "12px",
              fontFamily: "Helvetica",
            }}
          >
            {this.props.className}
          </div>
        </Row>
        <Row>
          <div
            style={{
              paddingLeft: "15px",
              marginBottom: "10px",
              position: "relative",
            }}
          >
            <div
              style={{
                width: "315px",
                height: "27px",
                marginTop: "5px",
                borderRadius: "3px",
                boxShadow:
                  "0px 0px 3px rgba(0, 0, 0, 0.25), inset 0px 0px 2px rgba(215, 213, 212, 0.45)",
                display: "flex",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  position: "absolute",
                  width: "315px",
                  textAlign: "right",
                  color: "#475A82",
                  fontSize: "12px",
                  fontWeight: "bold",
                  padding: "5px",
                  zIndex: "2",
                }}
              >
                {Math.ceil(value * 100) + "%"}
              </p>
              <div
                style={{
                  background: this.gRGB,
                  boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.25)",
                  borderRadius: "3px",
                  height: "27px",
                  width: Math.ceil(value * 315) +'px'
                }}
              ></div>
            </div> 
          </div>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    classNArr: state.classNArr,
  };
};

export default connect(mapStateToProps)(PredictionBar);
